module.exports = __webpack_public_path__ + "static/img/income-fixed.5b41a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cashflow-tour/income-fixed.png
// module id = KDmZ
// module chunks = 6